import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../components/shared';
import { ArrowRight } from 'lucide-react';

export const KompassPage = () => {
  return (
    <Layout>
      <PageHero
        title="Unser Kompass – Was uns bewegt"
        subtitle="Haltung, Verantwortung und Medizin mit menschlicher Nähe."
        backgroundImage="/images/Hero_Vertrauenssache.webp"
        ctaText="Unser Team kennenlernen"
        ctaLink="/ueber-uns/team"
      />

      <ContentSection
        title="Der Mensch steht im Mittelpunkt"
        content="Für uns beginnt gute Medizin immer mit Zuhören. Wir nehmen Ihre Sorgen ernst, erklären verständlich und begegnen Ihnen mit Respekt, Geduld und Aufmerksamkeit. Jeder Mensch bringt seine eigene Geschichte mit – und genau diese ist für uns der Ausgangspunkt jeder Behandlung."
        image="/images/Medizin_aus_Ueberzeugung.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Medizin heißt für uns: Begleiten"
        content="Wir verstehen uns nicht nur als Behandler, sondern als Begleiter. Wir stehen an Ihrer Seite, wenn Entscheidungen anstehen, wenn Unsicherheit da ist oder wenn der Weg durch Krankheit und Genesung unübersichtlich wird. Verlässlich, ehrlich und mit Zeit für das, was Ihnen wichtig ist."
        image="/images/Medizin_Begleiten.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <ContentSection
        title="Verantwortung übernehmen – gemeinsam"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Als Hausärzte tragen wir Verantwortung für Ihre langfristige Gesundheit. Wir koordinieren Ihre Behandlung, behalten den Überblick und arbeiten eng mit den Fachärzten im Medicum Diez zusammen. So entsteht Medizin, die verbindet – fachlich stark und menschlich zugewandt.
            </p>
            <Link to="/ueber-uns/medicum" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
              Das Medicum-Konzept
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        }
        image="/images/Das_Medicum_Prinzip.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Hausärzte mit Haltung in Diez"
        content="Die Praxis Dres. von Bergh im Medicum Diez steht für menschliche Hausarztmedizin, persönliche Begleitung und verantwortungsvolle Versorgung im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Lernen Sie uns kennen"
        subtitle="Vereinbaren Sie Ihren ersten Termin und erleben Sie unsere Praxis persönlich."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default KompassPage;
